import { Professions } from './professions.model';
import { Trainings } from './trainings.model';
import { environment } from 'src/environments/environment';


export class CandidatesProfiles {
  private id: number;
  private years_of_experience: string;
  private position_level: string;
  private level_of_study: string;
  private availability: string;
  private mobility: string;
  private status: string;
  private current_salary: string;
  private desired_salary: number;
  private professions: Professions;
  private trainings: Trainings;

  constructor(CandidatesProfiles: any) {
    this.id = CandidatesProfiles.id;
    this.years_of_experience = CandidatesProfiles.years_of_experience;
    this.position_level = CandidatesProfiles.position_level;
    this.level_of_study = CandidatesProfiles.level_of_study;
    this.availability = CandidatesProfiles.availability;
    this.mobility = CandidatesProfiles.mobility;
    this.status = CandidatesProfiles.status;
    this.current_salary = CandidatesProfiles.current_salary;
    this.desired_salary = CandidatesProfiles.desired_salary;
    this.professions = CandidatesProfiles.professions;
    this.trainings = CandidatesProfiles.trainings;
  }

  getId(): number {
    return this.id;
  }

  getYearsOfExperience(): string {
    return this.years_of_experience;
  }

  getPositionLevel(): string {
    return this.position_level;
  }

  getLevelOfStudy(): string {
    return this.level_of_study;
  }

  getAvailability(): string {
    return this.availability;
  }

  getMobility(): string {
    return this.mobility;
  }

  getStatus(): string {
    return this.status;
  }

  getCurrentSalary(): string {
    return this.current_salary;
  }

  getDesiredSalary(): number {
    return this.desired_salary;
  }

  getProfessions(): Professions {
    return this.professions;
  }

  getTrainings(): Trainings {
    return this.trainings;
  }

}